import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    current: null,
    loading: false,
    departments: [],
    holidays: []
};

const maintenanceSlice = createSlice({
    name: "maintenance",

    initialState,

    reducers: {
        setValue: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
        },
        setMaintenanceData: (state, action) => {
            // Copies all properties from action.payload onto state directly
            Object.assign(state, action.payload);
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});
export const { setValue, setMaintenanceData, setLoading } =
    maintenanceSlice.actions;
export default maintenanceSlice.reducer;
